module.exports = __webpack_public_path__ + "static/media/store--google.eec91698.svg";